import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const CustomerProfilesAndFields = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/software/jira/service-management/product-guide/tips-and-tricks/customer-service-management"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomerProfilesAndFields.header",
            defaultMessage: "Customer profiles & fields"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomerProfilesAndFields.body",
            defaultMessage:
                "Access all relevant information about the customer in one place. Add detail fields to customers and use them to customize queues and SLAs."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.CustomerProfilesAndFields.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about service management for customer support teams."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default CustomerProfilesAndFields;
